<template>
    <div>
        <div class="header">
            <div class="logo pointer" @click="return_">
                <img src="../../static/images/logo.png" alt="">
            </div>
            <div class="header_right">

                <img @click="return_" src="../../static/images/brand/guanbi.png" alt="">
            </div>
        </div>
        <div class="topkongbox"></div>
        <div class="main" :style="{ 'height': screenHeight + 'px' }">
        <div class="kongbox"></div>
        <div class="success_box">
            <img src="../../static/images/zhuceOK_icon.png" alt="">
            <h2>{{email}}</h2>
            <p>{{$t('m.registerSuccess_01')}}{{text}}{{$t('m.registerSuccess_02')}}</p>
            <div class="btnbox">
                <el-button type="danger" @click="login">{{$t('m.registerSuccess_03')}}</el-button>
            </div>
        </div>
            
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            screenHeight: '',
            email:'',
            text:this.$t('m.register_01')
        }
    },
    mounted() {
        window.screenHeight = document.documentElement.clientHeight; //实时高度
        this.screenHeight = window.screenHeight - 80 - 25;
        this.email = this.$router.currentRoute.query.email
        
        if(this.$router.currentRoute.query.pageType  ==1){
            this.text=this.$t('m.register_01')
        }else{
            this.text=this.$t('m.RetrievePWD_01')
        } 
    },
    methods: {
         return_() {
            this.$router.push({
                path: '/'
            })
        },
        login(){
            this.$router.push({
                path: '/account/login?email='+this.email
            })
        }

    }

}

</script>
<style lang="scss" scoped>
.header {

    width: 100%;
    height: 90px;

    background-color: #FFF;
    display: flex;
    justify-content: space-between;
    padding: 0 145px;
    align-items: center;

    .logo {
        img {
            width: 90px;
        }
    }

    .header_right {
        display: flex;
        align-items: center;

        img {
            width: 15px;
            height: 15px;
        }
    }
}
.topkongbox{
    height: 15px;
}
.main {
    width: 100%;
    
    background-image: url(../../static/images/brand/login_bac.png);
    background-size: 100% 100%;
    text-align: center;
    border-top: 5px solid #ef5843;
    .kongbox{
        height: 23vh;
    }
    img{
        width: 85px;
        height: 85px;
    }
    
    .success_box{
       ::v-deep .el-button{
        background-color: #ef5843;
       height: 56px;
       font-weight: bold;
       width: 180px;
       }
    }
    
    h2{
        margin-top: 20px;
    }
    p{
        margin-top: 10px;
    }
    .btnbox{
        margin-top: 40px;
        text-align: center;
    }
}

	// 宽度小于1200px
	@media screen and (max-width: 1200px){
		.header{
			height: 2.5rem;
			padding: 0 1rem;
			.logo{
				img{
					width: 2.275rem;
					height: auto;
					display: block;
				}
			}
		}
		// .mainkongbox{
		// 	height: 3rem!important;
		// }
		.loginbox{
			width: 100%!important;
			padding: 0 1rem;
		}
		.topkongbox{
			height: 0;
		}
		.btnbox{
			margin-top: 2.75rem!important;
		}
		.agreement{
			padding: 1rem ;
			// padding-bottom: 4rem;
			display: block!important;
			.orange{
				display: inline-block;
			}
		}
		// ::v-deep .el-button {
		// 	width: 100%!important;
		// 	font-weight: bold;
		// 	height: 52px;
		// 	margin: auto;
		// 	display: block;
		// 	background-color: #ef5843 !important;
		// }
		::v-deep .el-dialog {
			// background-color: #f6f7fa;
			width: 90%!important;
			margin-top: 10%!important;
		}
	}
</style>